import "three/examples/js/deprecated/Geometry";
import "./SubdivisionModifier";

// Die fixes hier schalten nervige Warnings in THREEJS aus

THREE.Box3.prototype.getCenter = function (target = new THREE.Vector3() ) {
    // if ( target === undefined ) {
    //
    //     console.warn( 'THREE.Box3: .getCenter() target is now required' );
    //     target = new Vector3();
    //
    // }

    return this.isEmpty() ? target.set( 0, 0, 0 ) : target.addVectors( this.min, this.max ).multiplyScalar( 0.5 );
}

/**
 * Schaltet nervige Warnings in THREEJS aus
 */
THREE.Box3.prototype.getSize = function ( target = new THREE.Vector3() ) {

    // if ( target === undefined ) {
    //
    //     console.warn( 'THREE.Box3: .getSize() target is now required' );
    //     target = new Vector3();
    //
    // }

    return this.isEmpty() ? target.set( 0, 0, 0 ) : target.subVectors( this.max, this.min );
}


/**
 * Schaltet nervige Warnings in THREEJS aus
 */
THREE.Box2.prototype.getSize = function ( target = new THREE.Vector2() ) {

    // if ( target === undefined ) {
    //
    //     console.warn( 'THREE.Box2: .getSize() target is now required' );
    //     target = new Vector2();
    //
    // }

    return this.isEmpty() ? target.set( 0, 0 ) : target.subVectors( this.max, this.min );
}


/**
 * Schaltet nervige Warnings in THREEJS aus
 */
THREE.Box2.prototype.getCenter = function ( target = new THREE.Vector2() ) {

    // if ( target === undefined ) {
    //
    //     console.warn( 'THREE.Box2: .getSize() target is now required' );
    //     target = new Vector2();
    //
    // }

    return this.isEmpty() ? target.set( 0, 0 ) : target.addVectors( this.min, this.max ).multiplyScalar( 0.5 );
}


/**
 * Schaltet nervige Warnings in THREEJS aus
 */
THREE.Plane.prototype.projectPoint = function ( point, target = new THREE.Vector3() ) {

    // if ( target === undefined ) {
    //
    //     console.warn( 'THREE.Plane: .projectPoint() target is now required' );
    //     target = new Vector3();
    //
    // }

    return target.copy( this.normal ).multiplyScalar( - this.distanceToPoint( point ) ).add( point );

}

/**
 * Schaltet nervige Warnings in THREEJS aus
 */
THREE.Plane.prototype.coplanarPoint = function ( target = new THREE.Vector3() ) {

    // if ( target === undefined ) {
    //
    //     console.warn( 'THREE.Plane: .coplanarPoint() target is now required' );
    //     target = new Vector3();
    //
    // }

    return target.copy( this.normal ).multiplyScalar( - this.constant );

}

THREE.Box3.prototype.getBoundingSphere = function () {

    var v1 = new THREE.Vector3();

    return function getBoundingSphere( target = new THREE.Sphere() ) {

        // if ( target === undefined ) {
        //
        //     // console.warn( 'THREE.Box3: .getBoundingSphere() target is now required' );
        //     target = new THREE.Sphere();
        //
        // }

        this.getCenter( target.center );

        target.radius = this.getSize( v1 ).length() * 0.5;

        return target;

    };

}()

THREE.Plane.prototype.projectPoint = function ( point, target = new THREE.Vector3()) {

    // if ( target === undefined ) {
    //
    //     // console.warn( 'THREE.Plane: .projectPoint() target is now required' );
    //     target = new THREE.Vector3();
    //
    // }

    return target.copy( this.normal ).multiplyScalar( - this.distanceToPoint( point ) ).add( point );

}

THREE.Color.prototype.getHSL = function ( target = { h: 0, s: 0, l: 0 } ) {

    // h,s,l ranges are in 0.0 - 1.0

    // if ( target === undefined ) {
    //
    //     console.warn( 'THREE.Color: .getHSL() target is now required' );
    //     target = { h: 0, s: 0, l: 0 };
    //
    // }

    var r = this.r, g = this.g, b = this.b;

    var max = Math.max( r, g, b );
    var min = Math.min( r, g, b );

    var hue, saturation;
    var lightness = ( min + max ) / 2.0;

    if ( min === max ) {

        hue = 0;
        saturation = 0;

    } else {

        var delta = max - min;

        saturation = lightness <= 0.5 ? delta / ( max + min ) : delta / ( 2 - max - min );

        switch ( max ) {

            case r: hue = ( g - b ) / delta + ( g < b ? 6 : 0 ); break;
            case g: hue = ( b - r ) / delta + 2; break;
            case b: hue = ( r - g ) / delta + 4; break;

        }

        hue /= 6;

    }

    target.h = hue;
    target.s = saturation;
    target.l = lightness;

    return target;

}

THREE.Box3.prototype.clampPoint = function ( point, target ) {

    if ( target === undefined ) {

        target = new THREE.Vector3();

    }

    return target.copy( point ).clamp( this.min, this.max );

}

THREE.Ray.prototype.at = function ( t, target ) {

    if ( target === undefined ) {

        target = new THREE.Vector3();

    }

    return target.copy( this.direction ).multiplyScalar( t ).add( this.origin );

}


THREE.Object3D.prototype.getWorldPosition = function ( target = new THREE.Vector3() ) {

    // if ( target === undefined ) {
    //
    //     // console.warn( 'THREE.Object3D: .getWorldPosition() target is now required' );
    //     target = new THREE.Vector3();
    //
    // }

    this.updateMatrixWorld( true );

    return target.setFromMatrixPosition( this.matrixWorld );

}

THREE.Object3D.prototype.getWorldQuaternion = function () {

    var position = new THREE.Vector3();
    var scale = new THREE.Vector3();

    return function getWorldQuaternion( target = new THREE.Quaternion() ) {

        // if ( target === undefined ) {
        //
        //     // console.warn( 'THREE.Object3D: .getWorldQuaternion() target is now required' );
        //     target = new THREE.Quaternion();
        //
        // }

        this.updateMatrixWorld( true );

        this.matrixWorld.decompose( position, target, scale );

        return target;

    };

}()

THREE.Ray.prototype.closestPointToPoint = function ( point, target = new THREE.Vector3() ) {

    // if ( target === undefined ) {
    //
    //     // console.warn( 'THREE.Ray: .closestPointToPoint() target is now required' );
    //     target = new Vector3();
    //
    // }

    target.subVectors( point, this.origin );

    var directionDistance = target.dot( this.direction );

    if ( directionDistance < 0 ) {

        return target.copy( this.origin );

    }

    return target.copy( this.direction ).multiplyScalar( directionDistance ).add( this.origin );

};

const _oldSceneClone = THREE.Scene.prototype.clone;
THREE.Scene.prototype.clone = function() {
    const clone = _oldSceneClone.apply(this);
    if(this.animationClips)
        clone.animationClips = this.animationClips;

    return clone;
}

THREE.Raycaster = class extends THREE.Raycaster {

    constructor(...args) {
        super(...args);
        if (typeof STAGE!=='undefined') {
            this.params.Line.threshold = STAGE.settings.raycaster.linePrecision;
        }
    }

    // nur zum Überschreiben von _intersectObject da...
    ascSort = function ( a, b ) {
        return a.distance - b.distance;
    }

    isVisibleAllParents(object) {
        let o = object;
        while (true) {
            o=o.parent;
            if (o==null) {
                return true;
            }
            if (!this.isVisible(o)) {
                return false;
            }
        }
    }

    isVisible(object) {
        return object.visible && object.layers.test( this.layers );
    }

    // object.visible ist hier die wesentliche Änderung
    _intersectObject( object, intersects, recursive=true ) {
        if (this.isVisible(object)) {
            object.raycast( this, intersects );
            if ( recursive ) {
                object.children.forEach(child=>{
                    this._intersectObject( child, intersects, true );
                });
            }
        }
    }

    // nur zum Überschreiben von _intersectObject da...
    intersectObject( object, recursive, intersects = [] ) {
        if (this.isVisibleAllParents(object)) {
            this._intersectObject( object, intersects, recursive );
            intersects.sort( this.ascSort );
        }
        return intersects;
    }

    // nur zum Überschreiben von _intersectObject da...
    intersectObjects( objects, recursive, intersects = [] ) {
        if ( Array.isArray( objects ) === false ) {
            console.warn( 'THREE.Raycaster.intersectObjects: objects is not an Array.' );
            return intersects;
        }
        objects.forEach(object=>{
            if (this.isVisibleAllParents(object)) {
                this._intersectObject(object, intersects, recursive);
            }
        });
        intersects.sort( this.ascSort );
        return intersects;
    }

}


THREE.traverseAndConvertAllGeometryToBufferGeometry = object => {
    object.traverse(o=>{
        if (o.geometry && o.geometry instanceof THREE.Geometry) {
            o.geometry = o.geometry.toBufferGeometry();
        }
    });
};
